import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "emptyState"]
  static values = {
    index: { type: Number, default: 0 }
  }

  connect() {
    this.updateEmptyState()
    this.boundOnChange = this.onChange.bind(this)
    this.element.addEventListener("change", this.boundOnChange)
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundOnChange)
  }

  addBundle(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", this.indexValue)
    this.indexValue += 1
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    const row = this.containerTarget.lastElementChild
    this.applyQfMode(row, false)
    this.updateEmptyState()
  }

  removeBundle(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-bundle-row]")
    if (row) row.remove()
    this.updateEmptyState()
  }

  onChange(event) {
    const target = event.target
    if (!target.matches('input[type="radio"]')) return
    if (!/\[qf_mode\]$/.test(target.name)) return
    const row = target.closest("[data-bundle-row]")
    if (!row) return
    this.applyQfMode(row, target.value === "qf")
  }

  applyQfMode(row, enabled) {
    const qfBlock = row.querySelector("[data-qf-block]")
    const flatBlock = row.querySelector("[data-flat-block]")
    if (qfBlock) qfBlock.classList.toggle("hidden", !enabled)
    if (flatBlock) flatBlock.classList.toggle("hidden", enabled)

    qfBlock?.querySelectorAll("input").forEach(i => { i.disabled = !enabled })
    flatBlock?.querySelectorAll("input").forEach(i => { i.disabled = enabled })
  }

  updateEmptyState() {
    if (!this.hasEmptyStateTarget) return
    const hasRows = this.containerTarget.querySelector("[data-bundle-row]") !== null
    this.emptyStateTarget.classList.toggle("hidden", hasRows)
  }
}
